"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useModalSize = void 0;
var _reactRedux = require("react-redux");
var _uiActions = require("../../store/ui/uiActions");
var _uiSelectors = require("../../store/ui/uiSelectors");
var _constants = require("../../utils/constants");
var _widgetSelectors = require("../../store/widget/widgetSelectors");
var useModalSize = function useModalSize() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var currentModalSize = (0, _reactRedux.useSelector)(_uiSelectors.selectCurrentModalSize);
  var pageSizes = (0, _reactRedux.useSelector)(_widgetSelectors.selectSectionSizes);
  var getPageSize = function getPageSize(page) {
    return _constants.PAGE_SIZES[pageSizes[page]];
  };
  var setModalSizeByNumber = function setModalSizeByNumber(size) {
    dispatch((0, _uiActions.setModalSize)(size));
  };
  var setModalSizeByName = function setModalSizeByName(page) {
    dispatch((0, _uiActions.setModalSize)(getPageSize(page)));
  };
  return {
    currentModalSize: currentModalSize,
    setModalSizeByNumber: setModalSizeByNumber,
    setModalSizeByName: setModalSizeByName
  };
};
exports.useModalSize = useModalSize;